/* eslint-env browser */
var Backbone = require('backbone');
var _ = require('lodash');

var events = {};
_.assign(events, Backbone.Events);

module.exports = events;
